module.exports = __webpack_public_path__ + "static/img/18033D_1_2_3_R_20201106_fit.3bd1096.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18033D_1_2_3_R_20201106_fit.png
// module id = 6i7Q
// module chunks = 0